const MuiTab = {
    defaultProps: {
        iconPosition: 'start'
    },
    styleOverrides: {
        root: ({ ownerState, theme })=>({
                minHeight: 'min-content',
                padding: theme.spacing(1.5, 2),
                '& .MuiTab-iconWrapper': {
                    height: '16px',
                    width: '16px',
                    margin: 'start' === ownerState.iconPosition ? theme.spacing(0, 1.75, 0, 0) : theme.spacing(0, 0, 0, 1.75)
                }
            })
    }
};
const MuiTabs = {
    styleOverrides: {
        root: {
            minHeight: 'min-content'
        }
    }
};
export { MuiTab, MuiTabs };

//# sourceMappingURL=tabgroup-overrides.js.map